module.exports = __webpack_public_path__ + "img/toast.7da8353f.png";